import config from '../assets/config';
import { ax } from './base';

export default class ReportsService {

    //profit and loss
    GetProfitLoss(payload){
        return ax.post(`${config.apiUrl}DoubleEntrySystemReport/GetProfitLoss`,payload)
    }
    GetProfitAndLoss(payload){
        return ax.post(`${config.apiUrl}Report/GetProfitAndLoss`,payload)
    }
    GetProfitAndLossSummary(payload){
        return ax.post(`${config.apiUrl}Report/GetProfitAndLossSummary`,payload);
    }
    GetProfitLossBookView(payload){
        return ax.post(`${config.apiUrl}Report/GetProfitLossBookView`,payload);
    }
    GetCashFlowStatement(payload){
        return ax.post(`${config.apiUrl}Report/GetCashFlowStatement`,payload);
    }
    GetTradingReport(payload){
        return ax.post(`${config.apiUrl}Report/GetTradingReport`,payload);
    }

    //sales
    GetSalesByCustomer(payload){
        return ax.post(`${config.apiUrl}Report/GetSalesByCustomer`,payload);
    }
    GetSalesByItem(payload){
        return ax.post(`${config.apiUrl}Report/GetSalesByItem`,payload);
    }
    GetSalesReportSumnmary(payload){
        return ax.post(`${config.apiUrl}Report/GetSalesReportSumnmary`,payload);
    }
    GetSalesCreditNoteReport(payload){
        return ax.post(`${config.apiUrl}Report/GetSalesCreditNoteReport`,payload);
    }
    
    //balance sheet
    GetBalanceSheet(payload){
        return ax.post(`${config.apiUrl}Report/GetBalanceSheet`,payload);
    }
    
    //purchase and expenses
    GetPurchaseByVendor(payload){
        return ax.post(`${config.apiUrl}Report/GetPurchaseByVendor`,payload);
    }
    GetPurchaseByItem(payload){
        return ax.post(`${config.apiUrl}Report/GetPurchaseByItem`,payload);
    }
    GetPurchaseReportSumnmary(payload){
        return ax.post(`${config.apiUrl}Report/GetPurchaseReportSumnmary`,payload);
    }
    GetExpensesByCategory(payload){
        return ax.post(`${config.apiUrl}Report/GetExpensesByCategory`,payload);
    }
    GetPurchaseDebitNoteReport(payload){
        return ax.post(`${config.apiUrl}Report/GetPurchaseDebitNoteReport`,payload);
    }
    
    //Receivables
    GetCustomerBalance(payload){
        return ax.post(`${config.apiUrl}Report/GetCustomerBalance`,payload);
    }

    //Payables
    GetVendorBalance(payload){
        return ax.post(`${config.apiUrl}Report/GetVendorBalance`,payload);
    }
    GetInvoiceDetailsReport(payload){
        return ax.post(`${config.apiUrl}Report/GetInvoiceDetailsReport`,payload);
    }
    GetEstimateDetailsReport(payload){
        return ax.post(`${config.apiUrl}Report/GetEstimateDetailsReport`,payload);
    }

    //payment recived
    GetPaymentsReceived(payload){
        return ax.post(`${config.apiUrl}Report/GetPaymentsReceived`,payload);
    }
    GetTimeToGetPaid(TenantID){
        return ax.get(`${config.apiUrl}Report/GetTimeToGetPaid/${TenantID}`);
    }

    //Taxes
    GetTaxSummary(payload){
        return ax.post(`${config.apiUrl}Report/GetTaxSummary`,payload);
    }
    GetItemsTaxReport(payload){
        return ax.post(`${config.apiUrl}Report/GetItemsTaxReport`,payload);
    }
    GetItemsTaxSummary(payload){
        return ax.post(`${config.apiUrl}Report/GetItemsTaxSummary`,payload);
    }

}